export default __webpack_public_path__ + "static/media/icon-search-red.65ac0f87.svg";